import apiClient from '@/config/api';

export interface CampaignMessage {
  title: string;
  body: string;
}

export interface PushCampaign {
  id: string;
  key: string;
  name: string;
  enabled: boolean;
  triggerType: 'CRON' | 'ONESHOT' | 'EVENT_BATCH';
  cronExpr: string | null;
  targetType: 'ALL_ACTIVE' | 'CODE';
  messages: CampaignMessage[];
  rotation: 'DAILY_INDEX' | 'RANDOM_NODUP' | 'SINGLE';
  deepLink: string | null;
  description: string | null;
  createdAt: string;
  updatedAt: string;
}

export interface UpdatePushCampaign {
  enabled?: boolean;
  name?: string;
  messages?: CampaignMessage[];
  deepLink?: string | null;
  cronExpr?: string | null;
  rotation?: PushCampaign['rotation'];
  description?: string | null;
}

export const pushCampaignsApi = {
  async list(): Promise<PushCampaign[]> {
    const res = await apiClient.get('/admin/push-campaigns');
    return (res.data as { data: PushCampaign[] }).data;
  },
  async update(id: string, body: UpdatePushCampaign): Promise<PushCampaign> {
    const res = await apiClient.patch(`/admin/push-campaigns/${id}`, body);
    return (res.data as { data: PushCampaign }).data;
  },
};
